/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Text, theme, FlexContainer } from "@nordcloud/gnui";
import { DottedLine, SolidLine } from "~/components/Styled";

type Props = {
  targetColor: string;
  kpiName: string;
  additionalTitle?: string;
};

export function KpiLegend({ targetColor, kpiName, additionalTitle }: Props) {
  return (
    <FlexContainer direction="row" alignContent="flex-start">
      <FlexContainer
        alignContent="center"
        css={{ marginRight: theme.spacing.spacing04 }}
      >
        <DottedLine color={targetColor} />
        <Text color={theme.color.text.text02} size="xs" m={0}>
          KPI Target
        </Text>
        <SolidLine color={theme.color.text.text01} />
        <Text color={theme.color.text.text02} size="xs" m={0}>
          Total {kpiName}
        </Text>
        <When condition={additionalTitle != null}>
          <SolidLine color={theme.color.support.purple} />
          <Text color={theme.color.text.text02} size="xs" m={0}>
            {additionalTitle} {kpiName}
          </Text>
        </When>
        <When condition={kpiName === "Cost Allocation Coverage"}>
          <DottedLine color={theme.color.text.text01} />
          <Text color={theme.color.text.text02} size="xs" m={0}>
            Estimated Total {kpiName}
          </Text>
        </When>
      </FlexContainer>
    </FlexContainer>
  );
}
